import { render } from "./ErrorTips.vue?vue&type=template&id=df43568a&scoped=true"
import script from "./ErrorTips.vue?vue&type=script&lang=js"
export * from "./ErrorTips.vue?vue&type=script&lang=js"

import "./ErrorTips.vue?vue&type=style&index=0&id=df43568a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df43568a"]])

export default __exports__